<template>
  <div class="home">
    <div class="job-category-top">
      <div class="blue-back">
        <div class="wrap blue-inner">
          <p class="job-category-title">Ad Support</p>
          <h1 class="job-category-sub">広告運用サポートの求人情報</h1>
        </div>
      </div>
      <div class="wrap">
        <img alt="広告運用サポートトップ" src="@/assets/job-category/GH-kyujin-koukoku001.webp" class="top" />
        <div class="text">
          <p>
            インターネット広告の運用のお仕事に興味があり、時間的な自由を求める人は、岐阜市にある株式会社グレイトヘルプの求人をぜひチェックしてみてください。<br />弊社は、ウェブマーケティングに強みがあり、家事や子育てに忙しい主婦・主夫、フリーランス・個人事業主としてご自身のお仕事をしながら勤務される方が主となって活躍する職場です。<br />出勤曜日が自由、勤務時間が自由、無駄な拘束時間なしなど、仕事において時間的な制約がある人が働きやすい勤務条件と職場環境を整えています。
          </p>
          <img src="@/assets/ezgif.com-gif-maker-A.png" alt="説明イラスト" />
        </div>
        <img src="@/assets/ezgif.com-gif-maker-B.png" alt="雲" class="illust-b" />
      </div>
    </div>

    <div class="recommendation">
      <HomeRecommendation />
    </div>

    <div class="space-top-70 space-top-130">
      <HomeWorkPlace />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment2 />
    </div>

    <div class="space-top-130">
      <JobCategoryAboutWork :topImg="true" :middleImg="true" :imgPath1="'GH-kyujin-koukoku002.webp'"
        :imgPath2="'GH-kyujin-koukoku003.webp'" :subTitle="'広告運用サポートのお仕事について'"
        :detail="'広告運用サポート職として、まずは以下の業務を担当していただきます。マーケティング部門の上司のサポート業務がメインです。<br><br><span>マーケティングに関するサポート業務全般</span><br>クライアントから受諾しているお仕事のサポート業務です。マニュアルにそって遂行していく業務、または、上司から明確な指示があり、その指示どおりに遂行していく業務です。担当するお仕事のウエイトの85%程度です。必要となるのは、パソコンスキルと、業務内容を理解し、正確に遂行するスキルです。コーディングやプログラムの知識はなくてもできる仕事です。<ul style=margin-top:20px;><li>ホームページやECサイトの媒体制作のサポート業務（調査・マーケティング、コンテンツ設計・制作のサポート）</li><li>広告運用のサポート業務</li><li>SNS運用のサポート業務</li><li>クライアントが執筆したブログの文章チェックとブログへの投稿</li><li>ホームページに掲載する文章の誤字脱字チェック</li><li>ホームページやECサイトの外観のチェック</li><li>ECサイトの商品の価格改定、在庫数の変更、クーポン発行</li><li>ホームページのカレンダーやお知らせ欄の更新</li><li>売上や新規集客数の集計業務</li><li>ネットでの調査と調査結果の資料化（調査方法について明確な指示あり）</li></ul><br><br><span>一般事務作業</span><br>社内の一般事務業務です。マニュアルにそって遂行していく業務です。担当するお仕事のウエイトの10%程度です。<ul style=margin-top:20px;><li>売上や経費の明細のダウンロード業務</li><li>社内の消耗品の発注業務</li><li>不用品の回収業者の手配業務</li></ul><br><br><span>雑務</span><br>パソコンと向き合わない業務です。担当するお仕事のウエイトの5%程度です。<ul style=margin-top:20px;><li>掃除</li><li>ゴミ出し</li><li>書類の整理業務</li></ul><br><br>勤務評価によって、以下に記載のような、より高度なマーケティングの業務を担当していただきます。考える力が必要になる業務です。採用されたら必ずしていただく、という業務ではありません。勤務評価によって担当していただく業務です。担当していただく場合、昇給の優遇をします。業務内容は上司から明確に指示があります。このような業務を担当していただく場合、上記の業務のウエイトが下がり、よりスキルアップを目指せます。<ul style=margin-top:20px;><li>ホームページ制作のディレクション（調査・マーケティング、コンテンツ設計、コード担当やデザイン担当の業務管理）</li><li>広告運用の主担当業務</li><li>文章の作成業務、校正業務</li><li>SNSに投稿するコンテンツの作成と運用</li></ul>'"
        :skill="'入社の段階で、広告運用やマーケティングに関する知識や実務経験は不問です。仕事内容は上述のとおり、マーケティング部門の上司のサポート業務がメインで、入社後にすべてお教えします。パソコンの操作スキルは必須です。<ul style=margin-top:20px;><li>1日の多くをパソコンと向き合う仕事の実務経験</li><li>ExcelやWordを業務で日常的に使用した実務経験</li></ul><br>高度なパソコンスキルが必要なわけではありません。パソコンを使った仕事に慣れていて、パソコン操作に抵抗がなく、仕事がこなせるスキルがあれば応募可能です。これまでに1日のほとんどをパソコンと向き合った仕事の実務経験があればできる仕事です。<br>ExcelやWordについても高度なスキルが求められることはありません。Excelについては、カンタンな資料作成、調査結果をまとめるという業務が主です。関数やグラフの作成は業務で使うことがないので、これらのスキルは不問です。ExcelとWordを仕事で使った経験が十分にあれば問題ありません。<br><br>以下のような方は応募不可です。<ul><li>パソコンを使った実務経験が浅い</li><li>パソコンを使った仕事に慣れていない</li><li>ExcelやWordを使った仕事の経験が浅い</li><li>タイピングの速度が遅い</li></ul><br>パソコンスキルの他に、社内の上司やメンバーから依頼された内容を正確に理解し、遂行する力も必要になります。弊社のお仕事は、マニュアル、または、具体的な指示があり、それにそって遂行していくため、このスキルが必要です。'"
        :experience="'広告運用、ホームページ制作、ネットショップ制作、SEO対策、SNSなどのウェブのマーケティングで必要となる知識とスキルが身につきます。これらについて、世の中の書籍などで学べる「概論」ではなく、クライアントに結果を長年提供している本当のスキルと知識を習得することができます。<br>このスキルと知識があれば、「このお店はこうやれば集客を強化できる」「この商品はこう打ち出せば売れるな」ということがわかるようになります。<br>広告運用やホームページ、ネットショップについても、「こうやって作れば結果が出る」「ここを改善すればパフォーマンスが上がる」ということがわかるようになりますし、その設計もできるようになります。<br>このように業務を通して、最先端のウェブマーケティングのスキル・知識・経験を習得できます。<br>勤務評価に応じて、より高度な業務をお願いし、時給も優遇していきます。<br>ウェブマーケティングは、普段の生活では馴染みがない人が多いですが、その仕組みやノウハウがわかってくると、楽しいお仕事です。今現在、経験はなくても、ご自身のキャリアやスキルを活かして、ウェブマーケティングの業務を習得し、活躍したい、とうい人はぜひご応募ください。'" />
    </div>

    <div class="space-top-130 space-top-70">
      <JobCategoryInfo :job="'広告運用サポート'"
        :content="'マーケティングに関するサポート業務全般（Google/Yahoo!/Facebook広告などの運用業務、調査・マーケティング、媒体の更新業務、文章の作成・修正、チェック業務、データ管理、など）、一般事務、雑務'"
        :condition="'パソコンの操作スキル、Excel・Wordの実務経験<br>※上記の「必要となる対応・能力・スキル」に詳細を記載'"
        :pay="'1,100円～1,500円<br>※「長期間、勤務していただきたい」という思いから、スタートの時給は1,100円で、勤務評価と勤務年数によって時給が上がる評価制度をとっています。'"
        :raise="'20円〜100円/時（社内の全職種による実績）'" :pg="false" :wdn="false" :isNonInsurableEmployment="true"
        :isStopRecruitment="true" />
    </div>
    <div class="space-top-130 space-top-70">
      <HomeSelectionSchedule />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeQa :qaBoxList="qaBoxList" />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeContact id="contact" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeRecommendation from "@/components/Home/Recommendation.vue";
import HomeWorkPlace from "@/components/Home/WorkPlace.vue";
import HomeWorkEnvironment from "@/components/Home/WorkEnvironment.vue";
import HomeWorkEnvironment2 from "@/components/Home/WorkEnvironment2.vue";
import JobCategoryAboutWork from "@/components/JobCategory/AboutWork.vue";
import JobCategoryInfo from "@/components/JobCategory/Info.vue";

import HomeSelectionSchedule from "@/components/Home/SelectionSchedule.vue";
import HomeQa from "@/components/Home/Qa.vue";
import HomeContact from "@/components/Home/Contact.vue";

export default {
  name: "Home",
  components: {
    HomeRecommendation,
    HomeWorkPlace,
    HomeWorkEnvironment,
    HomeWorkEnvironment2,
    JobCategoryAboutWork,
    JobCategoryInfo,
    HomeSelectionSchedule,
    HomeQa,
    HomeContact,
  },
  props: {},
  data() {
    return {
      qaBoxList: [
        {
          id: 1,
          qestion: "自由出勤の仕組みについて教えてください。自由に休めますか？",
          answer:
            "他の従業員と業務の進捗への影響がないことを前提にした勤務時間の自由となります。入社時に、1週間あたりの勤務時間（週15時間～）を決定します。この勤務時間において、出勤曜日と勤務時間が自由という仕組みです。出勤予定日にお休みをとった場合は、原則として1週間以内に欠勤分の勤務時間を補填する勤務をしていただいています（欠勤の理由と業務状況によっては補填なしの場合もあり）。お子様の長期休暇時は、事前の申請と調整によって、勤務日数・勤務時間を通常よりも減らすことは可能です。この条件を満たせる方のみご応募可能となっています。",
        },
        {
          id: 2,
          qestion: "業務中に車を運転することはありますか？",
          answer:
            "職種によってはあります。頻度はまれです。社有車があります。ご自身のお車を使う場合は手当を支給しています。業務中にお車の運転ができないことを前提とした応募も可能ですので、応募書類にその旨をご記載ください。",
        },
        {
          id: 3,
          qestion: "未経験でも応募可能でしょうか？",
          answer:
            "入社の段階で、広告運用やマーケティングに関する知識や実務経験は不問です。入社の段階で、パソコンの操作スキルは必須です。詳細は当ページの「必要となる対応・能力・スキル」をご確認ください。",
        },
        {
          id: 4,
          qestion: "副業・フリーランスでの応募も可能でしょうか？",
          answer:
            "平日9時30分～17時のご希望の曜日・時間帯で週15時間以上の勤務ができる場合は応募可能です。",
        },
        {
          id: 5,
          qestion: "在宅勤務・テレワークは可能でしょうか？",
          answer:
            "事務所への出社での勤務となっています。緊急事態宣言時などのみ行う場合があり、在宅勤務は原則としてございません。",
        },
        {
          id: 6,
          qestion: "グレイトヘルプに勤務しながら、副業は可能でしょうか？",
          answer:
            "可能です。ただし、弊社での勤務がメインであることを前提とします。また、弊社の事業内容と競合する仕事などは制限がある場合がございます。",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  watch: {},
  methods: {},
  created() { },
};
</script>
<style lang="scss" scoped>
.job-category-top {
  .blue-back {
    background-color: var(--main);

    .blue-inner {
      position: relative;
      padding-top: 100px;
      padding-bottom: 150px;

      @media screen and (max-width: 767px) {
        margin-top: 70px;
      }

      h1,
      p {
        color: white;
      }
    }
  }

  .top {
    margin-top: -120px;
  }

  .text {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 30px;

    @media screen and (max-width: 767px) {
      display: block;
    }

    p {
      width: 80%;
      margin-bottom: 30px;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    img {
      width: 250px;

      @media screen and (max-width: 767px) {
        width: 200px;
        margin-left: calc(100% - 200px);
      }
    }
  }

  .illust-b {
    width: 200px;
    position: absolute;
    top: 60%;
    left: 15%;

    @media screen and (max-width: 1024px) {
      display: none;
    }
  }
}

.recommendation {
  background-color: var(--sub);
}
</style>